export default __webpack_public_path__ + "static/ehv-smooth-shiny-1022c0c2f26c1b0f0cbaba9d82c09876.webp";